import React, { PureComponent, Component, Option } from 'react'
import { Select, Checkbox, TextField, Input, Switch } from '@material-ui/core'

import { EditableSelect } from '../../common/EditableComponents'
import { MenuItem } from '@material-ui/core'

export const StatusComponent = (props) => {
  const { value } = props
  return <div>{value ? 'Active' : 'Inactive'}</div>
}

export class StatusEditor extends Component {
  state = { value: this.props.value }

  handleChange = (value) => this.setState({ value })
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const options = ['Active', 'Inactive']

    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableSelect
            editMode={true}
            material={false}
            name="active"
            onChange={this.handleChange}
            value={!!this.props.value}
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </EditableSelect>
        </div>
      </div>
    )
  }
}

export default {
  StatusComponent,
  StatusEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/StatusComponent.js